import _toConsumableArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _defineProperty2 from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/defineProperty";
import _slicedToArray from "E:\\Agents\\Agent-02\\_work\\1\\s\\src\\apps\\dotsite\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './RecommendationListing.css';
import React, { Fragment } from 'react';
import { canUseDOM, get, getColorByTheme, getDictionaryItem, getPageThemeColors, replaceUrlPluses } from '../../utils';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import LoadMore from '../DynamicListingComponent/LoadMore';
import getListing from '../../utils/getListing';
import { loadMoreButtonStylesLtr } from '../DynamicListingComponent/DynamicListingComponent';
import { POIBlock } from './../34_POIs/POIs';
import { ArticleBlock } from '../02_Articles/Articles';
import EventBlock from '../15_Events/components/EventBlock';
import FeaturedEventBlock from '../15_Events/components/FeaturedEventBlock';
import { commonStyles as itemStyles, RecommendationItenaryBlock } from '../26_Itineraries/Itineraries';
import { commonStyles as curatorltrStyles, CuratorBlock, rtlStyles as curatorRtlStyles } from '../10_Curators/Curators';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import Filters from './Filters';
import { qsToObject } from '../../utils/querystring';
import { useLocation } from 'react-router-dom';
import { convertQueryParamsToFacetsWithoutPlusReplacement, getAlgoliaTagsList } from './index';
import { getAnaliticsParamFromArray, tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import { UniversityBlock } from './UniversityBlock';
import { DealBlock } from './ListingBlocks/DealBlock';
import { DealModalBlock } from './ListingBlocks/DealModalBlock';
import { ServicesBlock } from './ListingBlocks/ServicesBlock';
import { eventDatesRange } from './DateRange';
import { VideoBlock, videoMedia } from '../BrightcoveVideos';
import { VenueBlock } from '../VenueBlock/VenueBlock';
import Modal from '../atoms/Modal/Modal';
import { useModal } from '../atoms/Modal/useModal';
import ResultItem from '../DynamicListingComponent/ResultItem';
import { usePrevious } from '../../utils/usePrevious';
import { convertToAnalyticObject } from '../../utils/analytics';
import { isShowRuleIsHide } from '../atoms/BlurCard/BlurCard';
import { checkJssError } from '../../utils/checkJssError';
import OfferAndDeal from '../102_ListingOffersAndDeals/components/OfferAndDeal';
var getFacetNamesValue = function getFacetNamesValue(filterData) {
  if (filterData) {
    return filterData.values.map(function (filter) {
      var item1 = get(filter, 'fieldNameItem.item.fieldName.value');
      var item2 = get(filter, 'fieldNameItems.items.0.fieldName.value');
      var facet = item1 || item2 || 'datesRange';
      if (facet === 'maxDelegates') {
        return 'maxDelegatesRangeIndex';
      }
      return facet;
    });
  } else {
    return [];
  }
};
var RecommendationListingComponent = function RecommendationListingComponent(_ref) {
  var fields = _ref.fields,
    params = _ref.params,
    route = _ref.route;
  var sitecoreContext = React.useContext(SitecoreContextReactContext);
  var rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  var pageTitle = get(sitecoreContext, 'route.fields.Title.value') || '';
  var currentLang = get(sitecoreContext, 'language');
  var searchIndexParams = get(params, 'SearchIndex', '');
  var _get = get(route, 'fields.Color Theme', [{}]),
    _get2 = _slicedToArray(_get, 1),
    fieldsColorTheme = _get2[0];
  var backgroundPrimaryColor = get(fieldsColorTheme, 'fields.Primary.fields.backgroundColor.value', '');
  var typeArray = get(fields, 'data.listingConfiguration.contentType.types') || [];
  var filterData = get(fields, 'data.listingConfiguration.filters') || [];
  var isTagPage = get(fields, 'data.listingConfiguration.isTagPage.jss.value');
  var filterValue = get(fields, 'data.listingConfiguration.filters.values') || [];
  var pagesize = Number(get(fields, 'data.listingConfiguration.pageSize.jss.value'));
  var pinnedArray = get(fields, 'data.listingConfiguration.pinnedTypes.types') || [];
  var isSumOrFiltersScores = get(fields, 'data.listingConfiguration.isSumOrFiltersScores.jss.value', false);
  var pinned = pinnedArray.length !== 0 ? pinnedArray.map(function (el) {
    return el.template.targetItem.value;
  }) : [];
  var tagsSlugMap = get(fields, "data.overwiewPages.pages").reduce(function (acc, slug) {
    var key = slug.contentType.targetItem.template.targetItem.value;
    var value = slug.link.jss.value.href;
    return _objectSpread(_objectSpread({}, acc), {}, _defineProperty2({}, key, value));
  }, {});
  var dictionary = get(fields, 'data.dictionary');
  var buttonsDictionary = get(fields, 'data.buttonsDictionary');
  var imageDictionary = get(fields, 'data.imageDictionary');
  var curatorPick = getDictionaryItem(dictionary, 'Curatorspick');
  var byCopy = getDictionaryItem(dictionary, 'By');
  var MinRead = getDictionaryItem(dictionary, 'MinRead');
  var LoadMoreCopy = getDictionaryItem(dictionary, 'LoadMore');
  var day = getDictionaryItem(dictionary, 'Day') || 'day';
  var days = getDictionaryItem(dictionary, 'Days') || 'days';
  var showLabel = getDictionaryItem(dictionary, 'Show') || 'show';
  var resultsLabel = getDictionaryItem(dictionary, 'Results') || 'results';
  var clearAllLabel = getDictionaryItem(dictionary, 'ClearAll') || 'ClearAll';
  var selectAllLabel = getDictionaryItem(dictionary, 'ShowAll') || 'Select all';
  var Cancel = getDictionaryItem(dictionary, 'Cancel') || 'Cancel';
  var FiltersCopy = getDictionaryItem(dictionary, 'Filters') || 'Filters';
  var meet = getDictionaryItem(dictionary, 'meet');
  var viewedNofMLabel = "".concat(getDictionaryItem(dictionary, 'YouHaveViewed'), " {#loadedHits#} ").concat(getDictionaryItem(dictionary, 'Of'), " {#nbHits#} ").concat(getDictionaryItem(dictionary, 'Items'));
  var multipleDates = getDictionaryItem(dictionary, 'multipleDates') || 'Multiple days, next on';
  var fromText = getDictionaryItem(dictionary, 'from') || '#';
  var offText = getDictionaryItem(dictionary, 'off') || '#';
  var expiresSoonText = getDictionaryItem(dictionary, 'expiresSoon') || '#';
  var moreInfoText = getDictionaryItem(dictionary, 'moreInfo') || '#';
  var bookNowText = getDictionaryItem(dictionary, 'Book now') || '#';
  var termsAndConditionsText = getDictionaryItem(dictionary, 'termsAndConditions') || '#';
  var readMoreText = getDictionaryItem(dictionary, 'readMore') || '#';
  var readLessText = getDictionaryItem(dictionary, 'readLess') || '#';
  var ratingTextStar = getDictionaryItem(dictionary, 'star') || '';
  var ratingTextStars = getDictionaryItem(dictionary, 'stars') || '';
  var messageSearchResultEmpty = get(fields, 'data.contextItem.messageSearchResultEmpty.value', '');
  var countryItems = get(fields, 'data.countries.countryValues') || [];
  var _React$useState = React.useState(),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    result = _React$useState2[0],
    setResult = _React$useState2[1];
  var _React$useState3 = React.useState(),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    facets = _React$useState4[0],
    setFacets = _React$useState4[1];
  var _React$useState5 = React.useState(),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    defaultFacets = _React$useState6[0],
    setdefaultFacets = _React$useState6[1];
  var _React$useState7 = React.useState({}),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    facetsStats = _React$useState8[0],
    setFacetsStats = _React$useState8[1];
  var _React$useState9 = React.useState([]),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    hits = _React$useState10[0],
    setHits = _React$useState10[1];
  var _React$useState11 = React.useState(0),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    nbHits = _React$useState12[0],
    setNbHits = _React$useState12[1];
  var _React$useState13 = React.useState(0),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    page = _React$useState14[0],
    setpage = _React$useState14[1];
  var _React$useState15 = React.useState(true),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    firstRendering = _React$useState16[0],
    setFirstRendering = _React$useState16[1];
  var _React$useState17 = React.useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    loading = _React$useState18[0],
    setLoading = _React$useState18[1];
  var _React$useState19 = React.useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    buttonPressed = _React$useState20[0],
    setButtonPressed = _React$useState20[1];
  var _React$useState21 = React.useState(0),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    countAlgoliaCalls = _React$useState22[0],
    setCountAlgoliaCalls = _React$useState22[1];
  var _React$useState23 = React.useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    isTypeSetToUrl = _React$useState24[0],
    setIsTypeSetToUrl = _React$useState24[1];
  var _React$useState25 = React.useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    resetFilter = _React$useState26[0],
    setResetFilter = _React$useState26[1];
  var _React$useState27 = React.useState(false),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    resetAllFilters = _React$useState28[0],
    setResetAllFilters = _React$useState28[1];
  var _React$useState29 = React.useState(false),
    _React$useState30 = _slicedToArray(_React$useState29, 2),
    setFilters = _React$useState30[0],
    applySetFilters = _React$useState30[1];
  var _React$useState31 = React.useState([]),
    _React$useState32 = _slicedToArray(_React$useState31, 2),
    currentTypes = _React$useState32[0],
    applycurrentTypes = _React$useState32[1];
  var pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  var location = useLocation();
  var _useModal = useModal(),
    isShown = _useModal.isShown,
    toggle = _useModal.toggle;
  var _React$useState33 = React.useState({}),
    _React$useState34 = _slicedToArray(_React$useState33, 2),
    dealModalItem = _React$useState34[0],
    setIdDealModalItem = _React$useState34[1];
  var _React$useState35 = React.useState(false),
    _React$useState36 = _slicedToArray(_React$useState35, 2),
    isChina = _React$useState36[0],
    setIsChina = _React$useState36[1];
  var _React$useState37 = React.useState(true),
    _React$useState38 = _slicedToArray(_React$useState37, 2),
    isVdsite = _React$useState38[0],
    setIsVdsite = _React$useState38[1];
  var isFirstLoadWithoutFacets = React.useRef(false);
  var urlParams = new URLSearchParams(canUseDOM ? window.location.search : undefined);
  var typeFromUrl = urlParams.get('type');
  React.useEffect(function () {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  var socialSharing = get(fields, 'data.socialSharing');
  var primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  var primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  var selectedPrimaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  var selectedPrimaryActiveColor = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  React.useEffect(function () {
    if (canUseDOM && document.body) {
      var primaryColor = selectedPrimaryColor;
      var color = getColorByTheme(selectedPrimaryColor);
      var activeColor = selectedPrimaryActiveColor;
      document.body.style.setProperty('--venue-table-background-color', primaryColor);
      document.body.style.setProperty('--venue-table-background-active-color', activeColor);
      document.body.style.setProperty('--venue-table-color', color);
    }
  }, []);
  var queryParams = qsToObject(location.search);
  if (Object.keys(queryParams).length !== 0) {
    for (var key in queryParams) {
      queryParams[key] = replaceUrlPluses(queryParams[key], key === 'tags' || key === 'itineraryDatesRange') || queryParams[key];
    }
  }
  var facetFilters = convertQueryParamsToFacetsWithoutPlusReplacement(queryParams, true, filterData);
  React.useEffect(function () {
    if (typeof document !== 'undefined') {
      var _urlParams = new URLSearchParams(document.location.search);
      var isC = Boolean(_urlParams.get('isChina') === 'true');
      setIsChina(isC);
    }
  }, []);

  // get default facets for types
  React.useEffect(function () {
    var algoliaIndexes = '';

    // China part ---start---
    if (!isChina) {
      var search = location.search;
      var urlParameter = new URLSearchParams(search).get('deal');
      if (urlParameter) {
        urlParameter = urlParameter.replaceAll('-', ' ');
        var itemFilter = {
          hitsPerPage: 1,
          facetFilters: [['type:Listing deal', 'type:Listing trade event', 'type:Listing vendor']],
          query: urlParameter
        };
        getListing(algoliaIndexes, itemFilter, undefined, isSumOrFiltersScores).then(function (response) {
          if (response && response.hits.length !== 0) {
            response.hits.forEach(function (hit) {
              if (urlParameter && hit.urlParameter.toLowerCase() === urlParameter.toLowerCase()) {
                setIdDealModalItem(hit);
              }
            });
            toggle();
          }
        });
      }
    }
    // China part ---end---
  }, []);
  var href = typeof window !== 'undefined' && typeof window.location !== 'undefined' ? window.location.href : null;
  var prevFacetFilters = usePrevious(facetFilters);
  var prevPage = usePrevious(page);
  React.useEffect(function () {
    var queryIndexes = Object.keys(queryParams).filter(function (k) {
      return k.indexOf("".concat(searchIndexParams, "_asc_")) > -1;
    })[0];
    var algoliaIndexes = '';
    if (queryIndexes) {
      algoliaIndexes = queryIndexes;
    } else {
      algoliaIndexes = get(params, 'SearchIndex');
    }
    var tag = 'tags:';
    if (canUseDOM) {
      var hash = window.location.hash;
      var hashvalue = hash.split('#tag=');
      if (hashvalue[1]) {
        tag = 'tags:' + decodeURI(hashvalue[1]);
      }
    }
    var types = typeArray.map(function (type) {
      var value = type && type.template.targetItem.value;
      return "type:".concat(value);
    });
    applycurrentTypes(types);
    var facetNames = getFacetNamesValue(filterData);
    var filters;
    var currentTagTypeArray = facetFilters.filter(function (subArray) {
      return subArray.some(function (item) {
        return item.startsWith('type:');
      });
    });
    var currentTagType = currentTagTypeArray[0] && currentTagTypeArray[0][0] ? currentTagTypeArray[0][0].split(":")[1] : null;
    if (currentTagType === "Event" || currentTagType === "Offer And Deal") {
      if (queryParams.datesRange) {
        filters = queryParams.datesRange.split('+').join(' ');
      } else {
        var filterValues = getAlgoliaTagsList(filterData);
        if (filterValues.indexOf(eventDatesRange) > -1) {
          filters = "datesRange.to > ".concat(Date.parse(new Date()) / 1000);
        }
      }
    }
    if (queryParams.valid) {
      filters = queryParams.valid.split('+').join(' ');
    }
    var isLoadedFeatureItem = firstRendering && types.length == 1 && types[0] == 'type:Event';
    var itemFilters = {
      filters: filters,
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFilters), [[tag]]),
      hitsPerPage: isLoadedFeatureItem ? pagesize + 1 : pagesize,
      page: page
    };
    var removeTypeFromArray = function removeTypeFromArray(arr) {
      return arr.filter(function (subArray) {
        return !subArray.some(function (item) {
          return item.startsWith('type:');
        });
      });
    };
    var facetFiltersWithoutType = removeTypeFromArray(facetFilters);
    var switchItemFilters = {
      facets: _toConsumableArray(facetNames),
      facetFilters: [_toConsumableArray(types)].concat(_toConsumableArray(facetFiltersWithoutType))
    };
    var listingRequest = function listingRequest() {
      setLoading(true);
      getListing(algoliaIndexes, itemFilters, undefined, isSumOrFiltersScores).then(function (response) {
        if (countAlgoliaCalls === 0) {
          setdefaultFacets(response.facets);
        }
        setCountAlgoliaCalls(function (prev) {
          return prev + 1;
        });
        setResult(response);
        applySetFilters(false);
        setNbHits(response.nbHits);
        if (response.hits.length) {
          if (buttonPressed) {
            setButtonPressed(false);
            var resultsBlocks = document.querySelectorAll('.results');
            if (resultsBlocks.length) {
              var lastResultsBlock = resultsBlocks[resultsBlocks.length - 1];
              var focusableList = lastResultsBlock.querySelectorAll('a, button, [tabindex="0"]');
              if (focusableList.length) {
                var lastFocusable = focusableList[focusableList.length - 1];
                lastFocusable.focus();
              }
            }
          }
          setHits(hits.concat(response.hits[0].featured && isLoadedFeatureItem && response.nbPages > 1 ? response.hits.splice(0, response.hits.length - 1) : response.hits));
        }
        setTimeout(function () {
          if (canUseDOM) {
            window.onscroll = function () {};
          }
        }, 100);
        setLoading(false);
        setFirstRendering(false);
        setResetAllFilters(false);
      });
      getListing(algoliaIndexes, switchItemFilters, undefined, isSumOrFiltersScores).then(function (response) {
        setFacets(response.facets);
      });
    };
    if (resetAllFilters) {
      listingRequest();
    } else if (setFilters) {
      listingRequest();
    } else if (isTypeSetToUrl && countAlgoliaCalls <= 1) {
      setIsTypeSetToUrl(false);
      listingRequest();
    } else {
      if (!isFirstLoadWithoutFacets.current) {
        // compare previous facet filters value to escape extra request

        if (prevFacetFilters && prevFacetFilters.length === 0) {
          prevFacetFilters = undefined;
        }
        if (JSON.stringify(facetFilters) !== JSON.stringify(prevFacetFilters) || page !== prevPage) {
          listingRequest();
        }
      } else {
        isFirstLoadWithoutFacets.current = false;
      }
    }
  }, [resetFilter, setFilters, page, buttonPressed, resetAllFilters, isTypeSetToUrl]);
  var resetFilterCallback = function resetFilterCallback() {
    setFacets(undefined);
    setResult(undefined);
    // setNbHits(0);
    // setNbHits2(0);
    setHits([]);
    setpage(0);
    setResetFilter(true);
  };
  var resetAllFiltersCallback = function resetAllFiltersCallback() {
    setResetAllFilters(true);
  };
  var _fields$data = fields.data,
    bannerClickAnalytics = _fields$data.bannerClickAnalytics,
    listingItemAnalytics = _fields$data.listingItemAnalytics,
    titleClickAnalytics = _fields$data.titleClickAnalytics,
    visitWebsiteAnalytics = _fields$data.visitWebsite,
    navBubblesAnalytics = _fields$data.navBubblesAnalytics,
    prevNextNavAnalytics = _fields$data.prevNextNavAnalytics,
    addToFavAnalytics = _fields$data.addToFavAnalytics,
    exploreMoreAnalytics = _fields$data.exploreMoreAnalytics,
    mobileSlidesAnalytics = _fields$data.mobileSlidesAnalytics,
    videoAnalytics = _fields$data.videoAnalytics,
    socialAnalytics = _fields$data.socialAnalytics,
    discoverMoreClickAnalytics = _fields$data.discoverMoreClickAnalytics,
    seeMoreAnalytics = _fields$data.seeMoreAnalytics,
    readMoreAnalytics = _fields$data.readMoreAnalytics,
    filterShowResultsAnalytics = _fields$data.filterShowResultsAnalytics,
    filterClearAllDateAnalytics = _fields$data.filterClearAllDateAnalytics,
    filterClickAnalytics = _fields$data.filterClickAnalytics,
    expandCollapseAnalytics = _fields$data.expandCollapseAnalytics,
    buttonClickAnalytics = _fields$data.buttonClickAnalytics;
  var eventsAnalytics = get(fields, 'data.eventsAnalytics') || [];
  if (eventsAnalytics.length) {
    eventsAnalytics = convertToAnalyticObject(eventsAnalytics);
  }
  var analytics = get(fields, 'data.analytics.parameters');
  var loadMore = function loadMore() {
    if (canUseDOM) {
      window.onscroll = function () {
        window.scrollTo(window.scrollX, window.scrollY);
      };
    }
    setButtonPressed(true);
    setpage(function (prevState) {
      return prevState + 1;
    });
    if (eventsAnalytics["loadMoreAnalytics"]) {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics["loadMoreAnalytics"], params));
    }
  };
  var setListingFilter = function setListingFilter(filtersRecived) {
    setpage(0);
    setHits([]);
    applySetFilters(true);
    // setdefaultFacets(result && result.facets);
    setFacetsStats(result && result.facets_stats);
    isFirstLoadWithoutFacets.current = firstRendering && facetFilters.length === 0;
  };
  if (!fields || !fields.data || !fields.data.listingConfiguration || !fields.data.overwiewPages || !fields.data.overwiewPages.pages) {
    console.warn('RecommendationListing component render skipped. No fields provided');
    if (pageEditing) {
      return /*#__PURE__*/React.createElement("div", {
        className: "no-data"
      }, "[RecommendationListing component is empty: please provide datasource]");
    }
    return null;
  }
  var getHostLink = function getHostLink() {
    if (canUseDOM) {
      var _urlParams2 = new URLSearchParams(window.location.search);
      var type = _urlParams2.get('type');
      var slug = type ? tagsSlugMap[type] : "";
      return "".concat(window.location.origin).concat(slug);
    }
    return window.location.origin;
  };
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: params['Anchor Url Parameter'],
    componentTabIndex: "disabled"
  }, /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: "Listing"
  }, Object.keys(dealModalItem).length !== 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Modal, {
    isShown: isShown,
    hide: toggle
  }, /*#__PURE__*/React.createElement(DealModalBlock, {
    event: dealModalItem,
    lang: currentLang,
    hostLink: getHostLink(),
    analytics: socialAnalytics,
    params: params,
    fields: fields,
    pageTitle: pageTitle,
    rtl: rtl
  }))), filterValue && filterValue.length >= 1 && /*#__PURE__*/React.createElement(Filters, {
    params: params,
    pinned: pinned,
    fields: filterData,
    currentTypes: currentTypes,
    facets: facets,
    defaultFacets: defaultFacets,
    facetsStats: facetsStats,
    showLabel: showLabel,
    resultsLabel: resultsLabel,
    nbHits: nbHits,
    clearAllLabel: clearAllLabel,
    selectAllLabel: selectAllLabel,
    setListingFilter: setListingFilter,
    resetFilterCallback: resetFilterCallback,
    FiltersCopy: FiltersCopy,
    isTagPage: isTagPage,
    lang: currentLang,
    hits: hits,
    dictionary: dictionary,
    buttonsDictionary: buttonsDictionary,
    imageDictionary: imageDictionary,
    firstQuery: facetFilters.length !== 0 ? facetFilters[facetFilters.length - 1][0].split(':')[0] : '',
    eventsAnalytics: eventsAnalytics,
    analytics: {
      filterShowResultsAnalytics: filterShowResultsAnalytics,
      filterClearAllDateAnalytics: filterClearAllDateAnalytics,
      filterClickAnalytics: filterClickAnalytics,
      params: params
    },
    resetAllFiltersCallback: resetAllFiltersCallback,
    searchIndex: searchIndexParams,
    setIsTypeSetToUrl: setIsTypeSetToUrl
  }), loading && /*#__PURE__*/React.createElement("div", {
    className: "Listing Listing--loader"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loader-t1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "loadingio-spinner-rolling-arlp0sgzkfu"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ldio-fryp34cx4ij"
  }, /*#__PURE__*/React.createElement("div", null))))), /*#__PURE__*/React.createElement(React.Fragment, null, currentTypes.map(function (type, index) {
    if (type === 'type:Article' && typeFromUrl === 'Article' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Article') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics: eventsAnalytics,
              params: params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:PressRelease' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:PressRelease')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "row",
        key: "results-row-".concat(index)
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xl-1"
      }), hits && hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement(ResultItem, {
          key: index,
          item: hit,
          language: currentLang,
          params: params,
          analitycs: {
            bannerClickAnalytics: bannerClickAnalytics,
            listingItemAnalytics: listingItemAnalytics
          }
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-xl-2"
      }), "s", ' ');
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Article Insights' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Article Insights')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Article Insights') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics: eventsAnalytics,
              params: params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Long Report Overview' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Long Report Overview')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Long Report Overview') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
            key: index
          }, /*#__PURE__*/React.createElement(ArticleBlock, {
            item: hit,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              eventsAnalytics: eventsAnalytics,
              params: params
            },
            removeDate: true
          }));
        }
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Venue' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Venue')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "article-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Venue') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 article-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(VenueBlock, {
            item: hit,
            dictionary: dictionary,
            copyBy: byCopy,
            copyMinread: MinRead,
            lang: currentLang,
            hostLink: getHostLink(),
            analytics: {
              titleClickAnalytics: titleClickAnalytics,
              bannerClickAnalytics: bannerClickAnalytics,
              addToFavAnalytics: addToFavAnalytics,
              seeMoreAnalytics: seeMoreAnalytics,
              readMoreAnalytics: readMoreAnalytics,
              addToFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Add Venue To Shortlist Param'), '0'),
              removeFromFavoriteAnalytics: get(getAnaliticsParamFromArray(analytics, 'Remove Venue From Shortlist Param'), '0'),
              params: params
            }
          }));
        }
      }), !loading && hits && !hits.length ? /*#__PURE__*/React.createElement("div", {
        className: "col-12"
      }, getDictionaryItem(dictionary, 'venues not found')) : null)))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Curator' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Curator')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "curator-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Curator') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 curator-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(CuratorBlock, {
            item: hit,
            meet: meet,
            hostLink: getHostLink(),
            analytics: {
              videoAnalytics: videoAnalytics,
              titleClickAnalytics: titleClickAnalytics,
              socialAnalytics: socialAnalytics,
              discoverMoreClickAnalytics: discoverMoreClickAnalytics,
              prevNextNavAnalytics: prevNextNavAnalytics,
              navBubblesAnalytics: navBubblesAnalytics,
              mobileSlidesAnalytics: mobileSlidesAnalytics,
              params: params
            },
            parentParams: params,
            selectedPrimaryColor: 'var(--main-color)'
          }));
        }
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:POI' && typeFromUrl === 'POI' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:POI')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-9"
      }, /*#__PURE__*/React.createElement("div", {
        className: "poi-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('POI') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 poi-item-col",
            key: index
          }, /*#__PURE__*/React.createElement(POIBlock, {
            item: hit,
            curatorsCopy: curatorPick,
            hostLink: getHostLink(),
            dictionary: getDictionaryItem(dictionary, 'reviews') || '',
            analytics: {
              eventsAnalytics: eventsAnalytics,
              bannerClickAnalytics: eventsAnalytics['bannerClickAnalytics'],
              titleClickAnalytics: eventsAnalytics['titleClickAnalytics'],
              navBubblesAnalytics: navBubblesAnalytics,
              prevNextNavAnalytics: prevNextNavAnalytics,
              addToFavAnalytics: addToFavAnalytics,
              exploreMoreAnalytics: exploreMoreAnalytics,
              mobileSlidesAnalytics: mobileSlidesAnalytics,
              params: params
            }
          }));
        }
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Event' && typeFromUrl === 'Event' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Event')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, hit && hit.featured && index === 0 && !isShowRuleIsHide(hit) ? /*#__PURE__*/React.createElement("div", {
          className: "col-12",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "events__featured-block"
        }, /*#__PURE__*/React.createElement(FeaturedEventBlock, {
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: getHostLink(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics: eventsAnalytics,
            params: params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
        }))) : null);
      }), /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-9 offset-xl-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, hit && hit.featured && index === 0 && !isShowRuleIsHide(hit) ? null : /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-sm-6 col-md-4 events-item-col-outer d-flex"
        }, /*#__PURE__*/React.createElement(EventBlock, {
          event: hit,
          curatorsCopy: curatorPick,
          lang: currentLang,
          hostLink: getHostLink(),
          multipleDates: multipleDates,
          analytics: {
            eventsAnalytics: eventsAnalytics,
            params: params
          },
          countryItems: countryItems,
          themeValues: [selectedPrimaryColor, getColorByTheme(selectedPrimaryColor)]
        })));
      })))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Itineraries' && typeFromUrl === 'Itineraries' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Itineraries')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "event-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-12 col-xl-9 offset-xl-1"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement(Fragment, {
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          className: "col-12 col-sm-6 col-md-4 events-item-col-outer"
        }, /*#__PURE__*/React.createElement(RecommendationItenaryBlock, {
          item: hit,
          day: day,
          curatorsCopy: curatorPick,
          days: days,
          hostLink: getHostLink(),
          analytics: {
            eventsAnalytics: eventsAnalytics,
            params: params
          }
        })));
      }))))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Offer And Deal' && typeFromUrl === 'Offer And Deal' && (!isTagPage || facetFilters[0] && facetFilters[0][0] === 'type:Offer And Deal')) {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          rowGap: '20px'
        }
      }, hits && hits.map(function (hit, index) {
        if (hit.type.indexOf('Offer And Deal') != -1) {
          return /*#__PURE__*/React.createElement("div", {
            className: "col-12 col-sm-6 col-md-4 ".concat(isShowRuleIsHide(hit) ? 'd-flex' : ''),
            key: index
          }, /*#__PURE__*/React.createElement(OfferAndDeal, {
            fromText: fromText,
            offText: offText,
            expiresSoonText: expiresSoonText,
            moreInfoText: moreInfoText,
            bookNowText: bookNowText,
            readMoreText: readMoreText,
            readLessText: readLessText,
            termsAndConditionsText: termsAndConditionsText,
            deal: hit,
            rtl: rtl,
            currency: 'AED',
            currencyIndex: 1,
            socialSharing: socialSharing,
            eventsAnalytics: eventsAnalytics,
            params: params,
            ratingTextStars: ratingTextStars,
            ratingTextStar: ratingTextStar,
            countryItems: countryItems,
            gridMode: false,
            useTruncate: false
          }));
        }
      })));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:University') {
      var anualFee = getDictionaryItem(dictionary, 'Annual Fee Range') || 'Anual Fee Range';
      var fieldOfStudy = getDictionaryItem(dictionary, 'Field Of Study') || 'Field of study';
      var visitWebsite = getDictionaryItem(dictionary, 'Visit website') || 'Visit website';
      var AED = getDictionaryItem(dictionary, 'AED') || 'AED';
      var universityDescription = getDictionaryItem(dictionary, 'university description');
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row itinerary-styles"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "universities-container"
      }, hits && hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement("div", {
          className: "university-container",
          key: index
        }, /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "university-container__row"
        }, /*#__PURE__*/React.createElement("div", {
          className: "university-main-container"
        }, /*#__PURE__*/React.createElement(UniversityBlock, {
          hit: hit,
          rtl: rtl,
          lang: {
            anualFee: anualFee,
            visitWebsite: visitWebsite,
            universityDescription: universityDescription,
            fieldOfStudy: fieldOfStudy,
            AED: AED
          },
          analytics: {
            bannerClickAnalytics: bannerClickAnalytics,
            titleClickAnalytics: titleClickAnalytics,
            visitWebsiteAnalytics: visitWebsiteAnalytics,
            prevNextNavAnalytics: prevNextNavAnalytics,
            addToFavAnalytics: addToFavAnalytics,
            exploreMoreAnalytics: exploreMoreAnalytics,
            mobileSlidesAnalytics: mobileSlidesAnalytics,
            params: params
          }
        }))));
      })))));
    }
  }), currentTypes.map(function (type, index) {
    if (type === 'type:Services Page') {
      return /*#__PURE__*/React.createElement("div", {
        className: "results",
        key: index
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "offset-xl-1 col-xl-11"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, hits && hits.map(function (hit, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: "col-sm-4 col-12"
        }, /*#__PURE__*/React.createElement(ServicesBlock, {
          service: hit,
          hostLink: "",
          rtl: rtl
        }));
      })))));
    }
  }), currentTypes.some(function (type) {
    return type === 'type:Listing deal' || type === 'type:Listing trade event' || type === 'type:Listing vendor';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "results DEALS-M44"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row itinerary-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-11"
  }, /*#__PURE__*/React.createElement("div", {
    className: "curator-featured"
  }, /*#__PURE__*/React.createElement("div", {
    className: "deals-container",
    style: {
      '--backgroundPrimaryColor': backgroundPrimaryColor
    }
  }, hits && hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "deal-container",
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      key: index,
      className: "deal-container__row"
    }, /*#__PURE__*/React.createElement("div", {
      className: "deal-main-container"
    }, /*#__PURE__*/React.createElement(DealBlock, {
      event: hit,
      lang: currentLang,
      hostLink: getHostLink(),
      analytics: {
        expandCollapseAnalytics: expandCollapseAnalytics,
        buttonClickAnalytics: buttonClickAnalytics
      },
      params: params,
      route: route,
      fields: fields,
      socialSharing: socialSharing,
      socialAnalytics: socialAnalytics
    }))));
  })))))), currentTypes.some(function (type) {
    return facetFilters.length && facetFilters[0].length && facetFilters[0][0].includes('type') ? type === 'type:Video Details Page' && facetFilters[0][0] === 'type:Video Details Page' : type === 'type:Video Details Page';
  }) && /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row itinerary-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits && hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "videoHolder ".concat(videoMedia)
    }, /*#__PURE__*/React.createElement(VideoBlock, {
      item: hit,
      index: index,
      hostLink: '',
      key: index,
      analytics: analytics,
      params: params,
      discoverMoreLink: getHostLink()
    }));
  }))))), currentTypes.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "results"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "offset-xl-1 col-xl-9"
  }, /*#__PURE__*/React.createElement("div", {
    className: "article-styles"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, hits && hits.map(function (hit, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "col-12 col-sm-6 col-md-4 article-item-col new-module",
      key: index
    }, /*#__PURE__*/React.createElement(ArticleBlock, {
      item: hit,
      copyBy: byCopy,
      copyMinread: MinRead,
      lang: currentLang,
      hostLink: getHostLink(),
      analytics: {
        eventsAnalytics: eventsAnalytics,
        params: params
      },
      removeDate: true
    }));
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-11"
  }, !loading && !hits.length && /*#__PURE__*/React.createElement("h4", {
    className: "  message-search-result-empty",
    dangerouslySetInnerHTML: {
      __html: messageSearchResultEmpty
    }
  }))), result && result.nbPages - 1 > result.page && /*#__PURE__*/React.createElement(LoadMore, {
    buttonLabel: LoadMoreCopy,
    onClick: loadMore,
    nbHits: result.nbHits,
    loadedHits: (page + 1) * pagesize,
    viewedNofMLabel: viewedNofMLabel
  })))));
};
var RecommendationListing = function RecommendationListing(props) {
  return checkJssError(props, RecommendationListingComponent, props.fields.data.listingConfiguration);
};
var StyledWrapper = function StyledWrapper(_ref2) {
  var children = _ref2.children,
    rtl = _ref2.rtl;
  return /*#__PURE__*/React.createElement("div", {
    className: "  ".concat(eventStyle, " ").concat(poiStyle, " ").concat(articleStyle, " ").concat(itemStyles, " ").concat(loadMoreButtonStylesLtr, " ").concat(curatorltrStyles, " ").concat(curatorStyle, " ").concat(commonStyles, " ").concat(rtl ? curatorRtlStyles : curatorltrStyles, " ").concat(rtl ? stylesRTL : stylesLTR, " ")
  }, children);
};
export var commonStyles = "c5is86k";
export var eventStyle = "etdpu34";
export var articleStyle = "atwzv95";
export var poiStyle = "p1hmzzl7";
export var curatorStyle = "c11ljqv4";
export var stylesLTR = "s9dmp0i";
export var stylesRTL = "su0y5dr";
export default RecommendationListing;